var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsightGrow = function SvgInsightGrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#FFE9D8",
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#730424",
    d: "M16.4 14.8a.8.8 0 0 1 .8-.8.8.8 0 0 0 0-1.6 2.4 2.4 0 0 0-2.4 2.4.8.8 0 0 0 1.6 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#730424",
    d: "M21.2 20.4a.8.8 0 0 1-.8.8v2.4a2.4 2.4 0 1 1-4.8 0v-2.4a.8.8 0 0 1-.8-.8v-.204a5.6 5.6 0 1 1 6.4 0zM14 15.6c0 1.48.803 2.772 2 3.465a.8.8 0 0 1 .384.535h3.232a.8.8 0 0 1 .383-.535 4 4 0 1 0-6-3.465m3.2 6.4h1.6v-.8h-1.6zm.8 2.4a.8.8 0 0 0 .8-.8h-1.6a.8.8 0 0 0 .8.8"
  })));
};
export { SvgInsightGrow as ReactComponent };
export default __webpack_public_path__ + "fonts/insight-grow-b7738d4493f93540fdcc64afc2a6f9a4.svg";